import React, { useContext } from 'react';
import classNames from 'classnames';
import CurrentUserEnquiryContextContext from 'providers/CurrentUserEnquiryContext/CurrentUserEnquiryContext.context';
import EnquiryContextTag from 'components/EnquiryContextTag';
import { useTranslation } from 'react-i18next';
import { getIsArrayEmpty } from 'utils';
import { UserEnquiryContext } from 'models/UserEnquiryContext';

import './EnquiryContextOptions.styles.scss';

type EnquiryContextOptionsProps = {
  className?: string;
  selectedContextId: string;
  onChange: (userEnquiryContext: UserEnquiryContext) => void;
};

const EnquiryContextOptions: React.FC<EnquiryContextOptionsProps> = (props) => {
  const { className, selectedContextId, onChange } = props;

  const { userEnquiryContext } = useContext(CurrentUserEnquiryContextContext);

  const classes = classNames('enquiry-context-options', className);

  const { t } = useTranslation();

  if (getIsArrayEmpty(userEnquiryContext)) return null;

  return (
    <div className={classes}>
      <p>{t('contextForInterest')}</p>

      <div>
        {userEnquiryContext.map((context) => (
          <EnquiryContextTag
            key={context._id}
            tag={context.tag}
            isActive={context._id === selectedContextId}
            onClick={() => onChange(context)}
          />
        ))}
      </div>
    </div>
  );
};

export default EnquiryContextOptions;
